(() => {
  const FEATURED = new Set([3, 10, 21, 36, 55, 78]);

  const updateFeatured = () => {
    document.querySelectorAll('#bls__product-grid > .bls__grid__item')
      .forEach((item, i) => item.classList.toggle('is-featured', FEATURED.has(i + 1)));
  };

  const init = () => {
    updateFeatured();

    document.querySelectorAll('.bls__collection-items').forEach(item => {
      if (item.querySelector('.bls__collection-title a')?.textContent.trim() === 'CORPORATE GIFTS') {
        item.querySelectorAll('a[href="#"]').forEach(a => {
          a.href = 'https://cdn.shopify.com/s/files/1/0604/1947/3475/files/CORPORATE_GIFTS.pdf?v=1790134657';
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        });
      }
    });

    document.querySelectorAll('ul.horizontal-list > li > a').forEach(a => {
      if (a.textContent.trim() === 'NEW ARRIVALS') a.style.color = 'red';
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  new MutationObserver(updateFeatured).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.querySelector(".channel-button.button-wrapper")?.addEventListener("click", () => {
    if (window.fbq) {
      window.fbq("track", "messenger_chat", {
        button_name: "Messenger chat",
        page_location: window.location.href,
      });
    }
    if(window.gtag) {
      window.gtag('event', 'messenger_chat', {
        button_name: "Messenger chat",
        page_location: window.location.href
      });
    }
  });

})();